module.exports = __webpack_public_path__ + "posture/static/img/spine_sideway_left.9e0c110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/spine_sideway_left.png
// module id = q80A
// module chunks = 1